/** Adresten sayfa adı: `<body data-bhs-page="…">` değerinin kaynağı.
 *
 * Panelden "yalnızca slot sayfasında şunu değiştir" demenin yolu budur. Ad
 * rotadan türetilir çünkü rota adresin kendisidir ve Türkçe yol adları
 * (`/slotlar`, `/canli-casino`) CSS'te okunur bir sözleşme oluşturmaz —
 * yöneticinin yazacağı değer sabit ve kısa olmalıdır.
 *
 * **Ad bir API'dir** (bkz. `domHooks.js`): kurulumların panelinde yazılmış CSS
 * ona bağlıdır, yeniden adlandırılmaz. Yeni bir rota eklerken buraya bir satır
 * yazın; yazılmazsa sayfa `other` görünür ve yöneticinin o sayfaya özel kuralı
 * hiç çalışmaz.
 */

// Sıra önemlidir: ilk eşleşen kazanır, yani daha uzun yol daha üstte durur.
const ROUTES = [
  [/^\/$/, 'home'],
  [/^\/slotlar(\/|$)/, 'slot'],
  [/^\/canli-casino(\/|$)/, 'live-casino'],
  [/^\/crash(\/|$)/, 'crash'],
  [/^\/spor(\/|$)/, 'sports'],
  [/^\/cark(\/|$)/, 'wheel'],
  [/^\/capa(\/|$)/, 'anchor'],
  [/^\/cekilis(\/|$)/, 'raffle'],
  [/^\/etkinlik(\/|$)/, 'prediction'],
  [/^\/promosyon-kodu(\/|$)/, 'promo-code'],
  [/^\/promosyonlar(\/|$)/, 'promotions'],
  [/^\/sponsorluk(\/|$)/, 'sponsorship'],
  [/^\/sayfa(\/|$)/, 'page'],
  // Oyunun kendi sayfası (bugün yalnızca Betrun; diğer şemalarda oyun bir
  // penceredir ve adres değişmez).
  [/^\/oyun(\/|$)/, 'game'],
  // Hesap bölümünün alt sayfaları `<body>`de ayrılmaz: kabuk ve düzen aynıdır.
  // Alt sayfanın adı hesap kökünde durur (`data-bhs-account-page`,
  // aşağıdaki `accountPageKey`).
  [/^\/hesap(\/|$)/, 'account'],
  [/^\/ortak(\/|$)/, 'partner'],
  [/^\/admin(\/|$)/, 'admin'],
];

export const PAGE_KEYS = ROUTES.map(([, key]) => key);

/** Adresin sayfa adı; tanınmayan yol `other` döner. */
export const pageKeyFromPath = (pathname) => {
  const path = String(pathname || '/');
  const match = ROUTES.find(([pattern]) => pattern.test(path));
  return match ? match[1] : 'other';
};

// Hesap alt sayfalarının adları (bkz. `domHooks.ACCOUNT_PAGES`). Yine ilk
// eşleşen kazanır: `para-yatir/odeme` `para-yatir`dan önce durur.
const ACCOUNT_ROUTES = [
  [/^\/hesap\/profil(\/|$)/, 'profile'],
  [/^\/hesap\/guvenlik(\/|$)/, 'security'],
  [/^\/hesap\/kyc(\/|$)/, 'kyc'],
  [/^\/hesap\/para-yatir\/odeme(\/|$)/, 'deposit-payment'],
  [/^\/hesap\/para-yatir(\/|$)/, 'deposit'],
  [/^\/hesap\/para-cek\/hesap(\/|$)/, 'withdrawal-account'],
  [/^\/hesap\/para-cek(\/|$)/, 'withdraw'],
  [/^\/hesap\/mesajlar(\/|$)/, 'messages'],
  [/^\/hesap\/islemler(\/|$)/, 'activity'],
  [/^\/hesap\/oyun-gecmisi(\/|$)/, 'game-history'],
  [/^\/hesap\/bahis-kuponlari(\/|$)/, 'coupons'],
  [/^\/hesap\/kayip-bonusu(\/|$)/, 'loss-bonus'],
  [/^\/hesap\/affiliate(\/|$)/, 'affiliate'],
  [/^\/hesap\/bonuslarim(\/|$)/, 'my-bonuses'],
  // Hesap bölümünün dışında ama bazı şemalarda hesap kabuğunda çizilir
  // (bkz. lib/accountMenu.js `PROMO_CODE_IN_ACCOUNT_THEMES`).
  [/^\/promosyon-kodu(\/|$)/, 'promo-code'],
];

/** Hesap alt sayfasının adı; tanınmayan yol `other` döner. */
export const accountPageKey = (pathname) => {
  const path = String(pathname || '');
  const match = ACCOUNT_ROUTES.find(([pattern]) => pattern.test(path));
  return match ? match[1] : 'other';
};
